import React from 'react';
import Animated from 'react-native-reanimated';
import { useAppSelector } from 'store/hooks';
import { AppView, Button, ButtonGroup, CardView, rem, SCROLL_INDICATOR_INSETS, SettingsItemNavigate, } from 'design-system';
import { HEIGHT } from 'design-system/Button';
import { IconBank, IconBell, IconSearch } from 'design-system/icons';
import { IconDots } from 'design-system/icons/IconDots';
import IconGraph from 'design-system/icons/IconGraph';
import IconInvest from 'design-system/icons/IconInvest';
import IconPieChart from 'design-system/icons/IconPieChart';
import IconPot from 'design-system/icons/IconPot';
import IconTransfer from 'design-system/icons/IconTransfer';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import DeleteNeedAssitanceCard from './DeleteNeedAssistanceCard';
const FEATURES_GB = [
    {
        name: 'Bank connections',
        icon: <IconBank gradientKey="ultimate"/>,
    },
    {
        name: 'Analytics',
        icon: <IconGraph gradientKey="plus"/>,
    },
    {
        name: 'Budgeting',
        icon: <IconPieChart gradientKey="turquoise"/>,
    },
    {
        name: 'Emma Invest',
        icon: <IconInvest gradientKey="darkPurple"/>,
    },
    {
        name: 'Emma Pots',
        icon: <IconPot gradientKey="apricot"/>,
    },
    {
        name: 'Emma Pay',
        icon: <IconTransfer gradientKey="lightPink"/>,
    },
    {
        name: 'Other',
        icon: <IconDots colorKey="negative"/>,
    },
];
const FEATURES_US_CA = [
    {
        name: 'Bank connections',
        icon: <IconBank gradientKey="ultimate"/>,
    },
    {
        name: 'Analytics',
        icon: <IconGraph gradientKey="plus"/>,
    },
    {
        name: 'Budgeting',
        icon: <IconPieChart gradientKey="turquoise"/>,
    },
    {
        name: 'Recurring payments',
        icon: <IconInvest gradientKey="darkPurple"/>,
    },
    {
        name: 'Search',
        icon: <IconSearch alt gradientKey="apricot"/>,
    },
    {
        name: 'Notifications',
        icon: <IconBell gradientKey="apricot"/>,
    },
    {
        name: 'Other',
        icon: <IconDots colorKey="negative"/>,
    },
];
const strings = {
    whichFeature: 'Which feature are you having problems with?',
    chooseAnOption: 'Choose an option 👇🏻',
    takeMeBack: 'Take me back',
};
const FeatureIssueScrollView = ({ onPressFeature, onPressBack, scrollHandler, }) => {
    const guessedHomeCountry = useAppSelector((store) => store.user.user.guessedHomeCountry);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), paddingHorizontalStyle);
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
        <ScreenInfoHeader title={strings.whichFeature} subTitle={strings.chooseAnOption}/>
        <CardView noMarginTop>
          {(guessedHomeCountry === 'GB' ? FEATURES_GB : FEATURES_US_CA).map((feature) => (<SettingsItemNavigate key={feature.name} title={feature.name} icon={feature.icon} onPress={() => onPressFeature(feature.name)}/>))}
        </CardView>
        <DeleteNeedAssitanceCard />
      </Animated.ScrollView>
      <ButtonGroup type="floating" margins>
        <Button title={strings.takeMeBack} brand testID="backButton" onPress={onPressBack}/>
      </ButtonGroup>
    </AppView>);
};
export default FeatureIssueScrollView;
